import { NextSeo, NextSeoProps } from 'next-seo';

const SeoCommon = ({ title, description, ...props }: NextSeoProps) => {
    return <NextSeo title={title} description={description} {...props} />;
};
export default SeoCommon;
